import React from 'react';
import './Definitions.css';

const Definitions = () => {
  return (
    <div className="wrapper definitions-wrapper">
      <div className="definitions-content">
        <div className='detail-header'>
          <h2>Business Context</h2>
        </div>
        <div className="coming-soon-container">
          <div className="coming-soon-content">
            <p className="coming-soon-text">Coming soon</p>
            <p className="coming-soon-description">Ability to provide business context for your AI Agents...</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Definitions;
